import(/* webpackMode: "eager", webpackExports: ["PopupProvider"] */ "/app/contexts/PopupContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootContextProvider"] */ "/app/contexts/RootContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Noto_Sans_KR\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"preload\":true}],\"variableName\":\"notoSansKr\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
